/* eslint-disable prefer-template */
import { useIntl } from 'react-intl-next';

import { useNotesData } from '@confluence/notes-util/entry-points/hooks/useNotesData.ts';
import { useActiveNoteId } from '@confluence/notes-util/entry-points/NotesStore.ts';
import { extractAdfText } from '@confluence/notes-util';

import { sharedI18n } from '../sharedI18n.ts';

const MAX_NOTES_TO_SHOW = 5;
const MAX_NOTE_LABEL_LENGTH = 20;

export const useContextualNotesList = () => {
	const { notesData } = useNotesData();
	const [activeNoteId] = useActiveNoteId();
	const intl = useIntl();

	// MODES-7071 Add any linked notes to the list
	const slicedNotes = notesData?.slice(0, MAX_NOTES_TO_SHOW) || [];

	const activeIndex = slicedNotes.findIndex((note) => note.ari === activeNoteId);

	if (activeIndex > 0) {
		// If active note is in the list but not at the top, bump it to the top
		const [activeNote] = slicedNotes.splice(activeIndex, 1);
		slicedNotes.unshift(activeNote);
	} else if (activeIndex === -1 && activeNoteId) {
		// If active note is not in the list, try to find it in notesData and add it to the top
		const activeNote = notesData.find((note) => note.ari === activeNoteId);
		if (activeNote) {
			slicedNotes.unshift(activeNote);
			// Remove last item to maintain MAX_NOTES_TO_SHOW
			if (slicedNotes.length > MAX_NOTES_TO_SHOW) {
				slicedNotes.pop();
			}
		}
	}

	// Generate the notes items to be used in the dropdown menu, each note have ari and label
	const notesList = slicedNotes.map((note) => ({
		ari: note.ari,
		label: (() => {
			const text = note?.title
				? note.title
				: (() => {
						const extracted = extractAdfText(note?.adf);
						if (!extracted) return intl.formatMessage(sharedI18n.untitledNote);
						return extracted;
					})();

			return text.length > MAX_NOTE_LABEL_LENGTH
				? text.slice(0, MAX_NOTE_LABEL_LENGTH - 1) + '...'
				: text;
		})(),
	}));

	return { notesList };
};
